export default __webpack_public_path__ + "static/media/quickbooks-1.ad5be09d.svg";